import { useEffect, useState } from "react";

import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { getAccessToken } from "./token";
import { ensureAccessTokenFreshBeforeUpload } from "../api/auth";
import { API_URL } from "../enums/api";
import { Optional } from "../enums/types";

const useUploadMedia = (formData: Optional<FormData>) => {
  const { t } = useTranslation();
  const [isMediaUploading, setIsMediaUploading] = useState<boolean>(false);
  const [uploadedMediaId, setUploadedMediaId] = useState<string>("");

  useEffect(() => {
    if (!formData) {
      setUploadedMediaId("");
      setIsMediaUploading(false);
      return undefined;
    }

    let canceled = false;
    setIsMediaUploading(true);

    (async () => {
      try {
        await ensureAccessTokenFreshBeforeUpload();
        const response = await axios.post(`${API_URL}upload`, formData, {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        });
        if (!canceled) {
          setUploadedMediaId(response.data.id);
        }
      } catch {
        if (!canceled) {
          toast.warning(t("app.image.upload.failed"));
        }
      } finally {
        if (!canceled) {
          setIsMediaUploading(false);
        }
      }
    })();

    return () => {
      canceled = true;
    };
  }, [formData, t]);

  return { uploadedMediaId, isMediaUploading };
};

export { useUploadMedia };
